<div class="waygate-order-summary">
  <ng-container *ngIf="cartData?.appliedVouchers?.length > 0">
    <div class="order-summary-coupon-text">
      {{ 'buyCart.couponCode' | cxTranslate }}
    </div>
    <div class="applied-coupon-holder">
      <span class="applied-coupon-icon mr-2"></span>
      <div class="coupons-holder">
        <span class="applied-coupon">{{
          cartData.appliedVouchers[0].code
        }}</span>
        <span class="applied-coupon-text">{{
          'buyCart.couponApplied' | cxTranslate
        }}</span>
      </div>
    </div>
    <hr class="horizontal-line" />
  </ng-container>

  <!-- <div class="available-coupon">View available coupons</div> -->

  <div class="order-summary-heading">
    <span *ngIf="!isQuote">{{ 'titles.orderSummary' | cxTranslate }}</span>
    <span *ngIf="isQuote">{{ 'titles.quoteSummary' | cxTranslate }}</span>
  </div>
  <ng-container *ngIf="!isQuote">
    <div class="order-summary-content">
      <div class="order-summary-sub-content">
        <div class="order-summary-label">
          {{ 'titles.subTotal' | cxTranslate }}
        </div>
        <div class="order-summary-value">
          {{ cartData?.totalListPrice?.formattedValue }}
        </div>
      </div>
      <!-- <div class="order-summary-sub-content">
      <div class="surcharge-label">
        Surcharge <i class="material-icons">info</i>
      </div>
      <div class="order-summary-value">$0.00</div>
    </div> -->
      <div class="order-summary-sub-content">
        <div class="order-summary-label">
          {{ 'titles.discount' | cxTranslate }}
        </div>
        <div class="order-summary-value">
          {{ cartData?.yourPriceDiscount?.formattedValue }}
        </div>
      </div>
      <!-- <div class="order-summary-sub-content">
      <div class="order-summary-label">NEWPROD2023</div>
      <div class="order-summary-value">- $550.00</div>
    </div> -->
      <div
        class="order-summary-sub-content"
        *ngIf="cartData?.totalDiscounts?.value > 0"
      >
        <div class="order-summary-label">
          {{ cartData?.appliedCouponCodes[0] }}
        </div>
        <div class="order-summary-value">
          {{ cartData?.totalDiscounts?.formattedValue }}
        </div>
      </div>
    </div>
  </ng-container>

  <hr class="horizontal-line" *ngIf="!isQuote" />
  <div class="order-summary-total" *ngIf="!isQuote">
    <div class="total-label">{{ 'titles.total' | cxTranslate }}</div>
    <div class="total-value">{{ cartData?.totalPrice?.formattedValue }}</div>
  </div>
  <div class="summary-total" *ngIf="isQuote">
    <div class="summary-total-cart">
      <p class="summary-total-cart-title">
        {{ 'quoteCart.cartTotal' | cxTranslate }}
      </p>
      <p class="summary-total-cart-value">
        {{ cartData?.totalPrice?.formattedValue }}
      </p>
    </div>
    <p class="summary-total-order">{{ 'quoteCart.billable' | cxTranslate }}</p>
  </div>
  <hr class="horizontal-line" />
  <div class="order-summary-des" *ngIf="!isQuote">
    <ng-container *ngIf="selectedSalesArea === '7140'">
      <p class="first">{{ 'titles.confirmTitle' | cxTranslate }}</p>
      {{ 'titles.confirmSubtitle1' | cxTranslate }}<br />
      {{ 'titles.confirmSubtitle2' | cxTranslate }}
      <p class="second">{{ 'titles.specialInst' | cxTranslate }}</p>
      {{ 'titles.specialInst1' | cxTranslate }}<br />
      {{ 'titles.specialInst2a' | cxTranslate
      }}{{ 'titles.specialInst2b' | cxTranslate
      }}{{ 'titles.specialInst2c' | cxTranslate }}
      <br />
      {{ 'titles.specialInst3a' | cxTranslate
      }}{{ 'titles.specialInst3b' | cxTranslate }}
      <p class="second">{{ 'titles.termsAndCon' | cxTranslate }}</p>
      {{ 'titles.termsAndCon1' | cxTranslate }}
      <!-- Below line for only china language -->
      <br /><a
        href="./../../../../../../assets/pdf/Waygate store_China Terms and conditions.pdf"
        target="_blank"
        >{{ 'titles.termsAndCon2' | cxTranslate }}</a
      ><br />
    </ng-container>
    <ng-container *ngIf="selectedSalesArea !== '7140'">
      {{ 'titles.checkoutTnCDes' | cxTranslate }}
    </ng-container>
  </div>
  <div class="order-summary-terms mt-2">
    <bh-checkbox
      class="float-left terms-checkbox"
      label=""
      [value]="agreeTerms"
      [attr.error]="error.agreeTerms ? error.agreeTerms : null"
      (change)="onChange(agreeTerms, 'agreeTerms')"
    >
    </bh-checkbox>
    <div>
      <label class="terms-checkbox-label" *ngIf="selectedSalesArea === '7140'">
        {{ 'titles.iagree' | cxTranslate }}
      </label>
      <label class="terms-checkbox-label" *ngIf="selectedSalesArea !== '7140'">
        {{ 'titles.iagreeto' | cxTranslate }}
        <a
          href="https://www.bakerhughesds.com/sales-terms-conditions"
          target="_blank"
        >
          {{ 'titles.termsConditions' | cxTranslate }}
        </a>
      </label>
    </div>
  </div>

  <div class="order-summary-actions">
    <bh-button
      *ngIf="!makePaymrnt"
      [attr.disabled]="!agreeTermschecked"
      class="float-left"
      [ngClass]="{ 'place-order-btn': !isQuote, 'margin-r': isQuote }"
      medium
      type="primary"
      label="{{
        !isQuote
          ? ('titles.placeOrder' | cxTranslate)
          : ('titles.submitQuoteReq' | cxTranslate)
      }}"
      (click)="placeOrder()"
    ></bh-button>
    <bh-button
      *ngIf="makePaymrnt"
      [attr.disabled]="!agreeTermschecked"
      class="float-left place-order-btn"
      medium
      type="primary"
      label="{{ 'titles.makePayment' | cxTranslate }}"
      (click)="placeOrder()"
    ></bh-button>
    <bh-button
      class="float-right"
      medium
      type="secondary"
      label="{{ 'titles.returntocart' | cxTranslate }}"
      (click)="goToCart()"
    >
    </bh-button>
  </div>
  <div class="order-summary-actions">
    <div *ngIf="noCartEntriesData" class="availibility-error">
      <i class="material-icons">report</i>
      <span class="error-text">
        {{ 'errors.technicalErrorsInCHeckout' | cxTranslate }}
        'ogmchybris.support&#64;bakerhughes.com'
        {{ 'errors.forAssistance' | cxTranslate }}
      </span>
    </div>
  </div>
</div>
